export default __webpack_public_path__ + "static/media/butterfly-insect-animal-shape.0d3f1552.svg";